// removed by extract-text-webpack-plugin
module.exports = {"itemListContainer":"itemThumbnailCarousel-module_itemListContainer_1IE7u","itemList":"itemThumbnailCarousel-module_itemList_1sWSL"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/itemThumbnailCarousel/itemThumbnailCarousel.module.css
// module id = 466
// module chunks = 1 3